module.exports = __webpack_public_path__ + "img/legendbody.81a80a7b.png";